import { Location } from '@angular/common';
import { inject, Injectable, Injector } from '@angular/core';
import { JkMenuService } from './jkmenu.service';
import { JkBDbService } from './jkBdb';
import { AppPage, jkAlert } from './jkClass';
import { login, LoginService } from './jkUser';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  login: LoginService;// = inject(LoginService);
  jkBDb: JkBDbService = inject(JkBDbService);

  appPages: AppPage[] = [];
  get isLogin(): boolean {
    return this.login.isLogin
  }
  //sw: ServiceworkService;
  get username(): string {
    return this.login.name;
  }
  get avatarIcon(): string {
    return this.login.avatarIcon;
  }

  constructor() {
    //super(injector);
    this.login = login;
    //this.sw = new ServiceworkService(); FIXME: 這樣寫會有問題
  }
  init(pages: AppPage[]) {
    this.appPages = pages;
  }
  navigateTo(router: Router, page: string, queryParams: any = {}) {
    if (router)
      return router.navigate([page], { queryParams })
    else {
      alert('無法導向:' + page + ' router 不存在');
      return false;
    };
  }

  doLogin(router: Router) {
    this.navigateTo(router, '/login-form');
  }
  onAvatarClick() {
    alert('onAvatarClick');
  }
  logout() {
    this.login.logout(this.login.hostName);
  }
  doUpdate(router: Router) {
    //if(this.page) {
    let url = window.location.host;
    let param = { timestamp: new Date().getTime() };
    this.navigateTo(router, '/', param);
    window.location.reload();
  }
  exitapp(location: Location) {
    //navigator['app'].exitApp();
    if (location)
      location.back();
  }
  registerApp() {
    let msg = 'registerApp 未完成 ';//this.sw.registerServiceWorker(); FIXME: 這樣寫會有問題
    jkAlert(msg);
  }
  async getMainMenu(myMenu: JkMenuService, appId: string) {
    let m = await this.jkBDb.getMainMenu(this.login.userid, appId);
    if (myMenu) {
      myMenu.mergePageAndTree(this.appPages, m);
    } else {
    }
  }
  doMenu(router: Router, id: string) {
    //if(this.page){
    let p = this.appPages.find((p) => p.id === id);
    if (p) {
      this.navigateTo(router, p.url || '/');
    } else {
      alert('找不到程式代號:' + id);
    }
    //}
  }
}
